var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`star-rating-${_vm.align} star-rating `},[_c('label',{attrs:{"for":"rating"}},[_vm._v(_vm._s(_vm.fieldLabel))]),_c('div',{staticClass:"stars"},_vm._l((5),function(star,index){return _c('span',{key:index,class:{'rated': index < _vm.rating},on:{"click":function($event){return _vm.setRating(index + 1)}}},[_vm._v(" ★ ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }